<div matRipple class="card" [style.margin-right.rem]="1">
  <div class="insight-card">
    <div class="text-container">
      <ngx-shimmer-loading [width]="'100%'" [height]="'12px'"></ngx-shimmer-loading>
      <ngx-shimmer-loading [width]="'100%'" [height]="'18px'"></ngx-shimmer-loading>
    </div>
  </div>
</div>
